export default (that) => [
  {
    field: "seq",
    width: 50,
    align: "center",
    type: "seq",
  },
  {
    title: that.$l('table_label_needQty')||"需求数量",
    field: "needQty",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_hasQty')||"已采购数",
    field: "hasQty",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_stockQty')||"已入库数",
    field: "stockQty",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_scheduleDate')||"计划日期",
    field: "scheduleDate",
    minWidth: 150,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_modified_by") || "修改人姓名",
    field: "modifyByName",
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_modification_time") || "修改时间",
    field: "modifyDate",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
